<template>
    <select v-model="perPage" @change="pageChange($event)"
        class="themePageChangeSelect w-16 bg-gray-200 text-sm text-gray-700 outline-0 px-1 py-0.5 bg-transparent hover:bg-gray-700 rounded-sm cursor-pointer">
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
    </select>
</template>
<script>
export default {
    name: "ChangePage",
    data() {
        return {
            perPage: 10,
        }
    },
    methods: {
        pageChange(event) {
            this.$emit('pageChange', event, this.perPage);
        }
    }
}
</script>